import { Flex, useStyles } from '@archipro-design/aria';
import type { TileProps } from '../../type';
import * as S from './RecentlyViewed.style';
import { Link } from 'react-router';

import { useTracker } from '@archipro-website/tracker';
import ArchizeenTile from '~/modules/tile/component/archizeen-tile/ArchizeenImpressionTile';
import { useLocalisation } from '@archipro-website/localisation';
import { getFormattedLocalisedDate } from '@modules/date-time/util/get-localised-date';

const RecentlyViewed: React.FC<{
    recentlyViewed: TileProps[];
}> = ({ recentlyViewed }) => {
    const { css } = useStyles();
    const tracker = useTracker();
    const { localiseDate } = useLocalisation();

    return (
        <div className={css(S.Wrap)}>
            <div className={css(S.MobileTitle)}>Recently viewed</div>
            <Flex className={css(S.TileSlideOuterWrap)}>
                <Flex className={css(S.TileSlideWrap)}>
                    {recentlyViewed.map((article) => {
                        const {
                            link,
                            ID,
                            title,
                            image,
                            canEdit: _canEdit,
                            bmEditorLink: _bmEditorLink,
                            professionalID: _professionalID,
                            date,
                            ...rest
                        } = article;
                        return (
                            <div className={css(S.TileSlide)} key={ID}>
                                <ArchizeenTile
                                    key={ID}
                                    as={Link}
                                    to={link}
                                    prefetch="intent"
                                    {...rest}
                                    variant="04"
                                    date={getFormattedLocalisedDate(
                                        localiseDate,
                                        date,
                                    )}
                                    size={'small'}
                                    favouritePosition="card"
                                    title={{
                                        children: title,
                                        maximumLines: 3,
                                    }}
                                    variables={{
                                        tilePadding: 0,
                                    }}
                                    onClick={() => {
                                        tracker.log(
                                            'ArticleRecentlyViewedClick',
                                            {
                                                url: new URL(
                                                    window.location.href,
                                                ),
                                                targetTracker:
                                                    'archiproTracker',
                                                data: {
                                                    // ArticleID
                                                    ExtraData: article.ID,
                                                },
                                            },
                                        );
                                    }}
                                    image={{
                                        src: image,
                                        alt: title,
                                    }}
                                    impression={{
                                        professionalID: article.professionalID,
                                        itemID: ID,
                                        type: 'RecentlyViewed',
                                    }}
                                    articleId={ID}
                                />
                            </div>
                        );
                    })}
                </Flex>
            </Flex>
        </div>
    );
};

export default RecentlyViewed;
